import { LoadingOutlined } from '@ant-design/icons';
import { Pagination, Row, Select, Space } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';
import CountUp from 'react-countup';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import PieChart from '../../components/dashBoardCharts/PieChart';
import DashboardTable from '../../components/dashBoardCharts/dashboardTable';
import { FacilityChart } from '../../components/dashBoardCharts/facilityChart';
import { FacilityLocationChart } from '../../components/dashBoardCharts/facilityLocationChart';
import { GuestsChart } from '../../components/dashBoardCharts/guestsChart';
import SearchableDropdown from '../../components/searchableDropdown';
import { IFacilityDetails } from '../facilityPage/facilityInterface';
import {
  facilityInfo,
  fetchAllFacility,
} from '../facilityPage/slices/facilitySlice';
import './index.scss';
import { IDashbord } from './interface';
import {
  dashboardInfo,
  downloadTableData,
  fetchAllTotalCountDetails,
  getTableData,
  getTotalBookingInDashBoard,
} from './slices';

const DashBoardPage: React.FC = () => {
  const [month, setMonth] = useState(moment().format('YYYY-MM'));
  const [tableMonth, setTableMonth] = useState(moment().format('YYYY-MM'));
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [currency, setCurrency] = useState<string>('USD');
  const [facilitySearch, setFacilitySearch] = useState<string>('');
  const [facilityId, setFacilityId] = useState<string>('');
  const [facilityIdInTable, setFacilityIdInTable] = useState<string>('');
  const [tableFilter, setTableFilter] = useState<string>('');
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAllTotalCountDetails());
  }, []);
  const dashboardInformation: IDashbord = useAppSelector(dashboardInfo);
  const [tablePage, setTablePage] = useState(0);
  const {
    allTotalCount,
    isGetTotalCount,
    TotalBookings,
    tableSummary,
    istableSummaryFetching,
    isTotalBookingsLoading,
    istableSummarydownloading,
  } = dashboardInformation;
  const facilityInformation: IFacilityDetails = useAppSelector(facilityInfo);
  const { allFacilityList, isGetAllFacilityRequest } = facilityInformation;
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />
  );
  useEffect(() => {
    dispatch(getTotalBookingInDashBoard({ month, currency, facilityId }));
  }, [month, currency, facilityId]);
  useEffect(() => {
    dispatch(
      getTableData({
        month: tableMonth,
        searchTerm,
        page: tablePage,
        facilityId: facilityIdInTable,
        filter: tableFilter,
      })
    );
  }, [tableMonth, searchTerm, tablePage, facilityIdInTable, tableFilter]);
  const pieSectionData = TotalBookings?.data?.[0];
  const currentDate = new Date();
  // get current month and date in some format
  const maxMonth = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, '0')}`;
  const handleDateOnGraph = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMonth(moment(event.target.value).format('YYYY-MM'));
  };
  const handleDateOnTable = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTableFilter('');
    setTableMonth(moment(event.target.value).format('YYYY-MM'));
  };
  useEffect(() => {
    dispatch(fetchAllFacility({ name: facilitySearch, page: 0, pageSize: 20 }));
  }, [facilitySearch]);
  const handleTableSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setTablePage(0);
    const form = event.currentTarget;
    const input = form.elements.namedItem('search') as HTMLInputElement;

    if (input) {
      setSearchTerm(input.value);
    }
  };

  const searchOption = allFacilityList?.map((item) => {
    return {
      label: item?.facilityName,
      value: item?.id,
    };
  });
  const Headerstyles = {
    fontSize: pieSectionData?.totalBookings ? '24px' : '80px',
    marginBottom: pieSectionData?.totalBookings ? '0px' : '20px',
  };
  const handleOnchange = (value: string) => {
    if (!value) {
      setSearchTerm('');
    }
  };
  return (
    <>
      {/* <Carousel autoplay dotPosition="bottom"> */}
      <div className="dash-number-card-container">
        <Row gutter={[16, 16]}>
          <Space size="large">
            <div className="dashboard-img-1 background-img-1">
              {isGetTotalCount ? (
                <div className="div-font-1">0</div>
              ) : allTotalCount[0]?.facilitiesCount > 0 ? (
                <div className="div-font-1">
                  <CountUp
                    end={allTotalCount && allTotalCount[0]?.facilitiesCount}
                    duration={1}
                  />
                </div>
              ) : (
                <div className="div-font-1">0</div>
              )}
              <div className="div-font-2 inter-12">
                Total Number Of Facilities
              </div>
            </div>

            <div className="dashboard-img-1 background-img-3">
              {isGetTotalCount ? (
                <div className="div-font-1">0</div>
              ) : allTotalCount[0]?.guestCount > 0 ? (
                <div className="div-font-1">
                  <CountUp
                    end={allTotalCount && allTotalCount[0]?.guestCount}
                    duration={1}
                  />
                </div>
              ) : (
                <div className="div-font-1">0</div>
              )}
              <div className="div-font-2 inter-12">
                Number Of Guests Onboarded
              </div>
            </div>
          </Space>
        </Row>
      </div>

      <div className="dash-board-container">
        <div className="chart-container-row">
          <div className="chart-div-1">
            <div className="no-of-facilities-onboarded-by-month">
              Number Of New Facilities Onboarded By Month
            </div>
            <FacilityChart />
          </div>
          <div className="chart-div-1">
            <div className="no-of-facilities-onboarded-by-month">
              Number Of Guests By Month
            </div>
            <GuestsChart />
          </div>
        </div>
        <div className="chart-container-row">
          <div className="chart-div">
            <div className="no-of-facilities-onboarded-by-month">
              Facilities By Location
            </div>
            <FacilityLocationChart />
          </div>
          <div className="chart-div first-graph">
            <div className="total-bookings-heading-section">
              <h3 className="tb-heading">Total Bookings</h3>
              <div className="tb-button-container">
                <SearchableDropdown
                  setSearch={setFacilitySearch}
                  listItems={searchOption}
                  loading={isGetAllFacilityRequest}
                  submitValue={setFacilityId}
                />
                <div className="month-picker-wraper">
                  <input
                    className="month-picker-dashboard"
                    type="month"
                    max={maxMonth}
                    value={month}
                    onChange={(event) => handleDateOnGraph(event)}
                  />
                  <div className="calender-image-container">
                    <img
                      width={24}
                      height={24}
                      src="/assets/calender.svg"
                      alt=""
                    />
                  </div>
                </div>
                <Select
                  value={currency}
                  style={{ width: 141, height: 41 }}
                  onChange={(value) => setCurrency(value)}
                  options={[
                    { value: 'USD', label: '$ USD' },
                    { value: 'EUR', label: '€ EUR' },
                  ]}
                />
              </div>
            </div>
            {!isTotalBookingsLoading ? (
              <div className="total-booking-chart-section">
                <div className="dashboard-pie">
                  <PieChart status={pieSectionData} />
                  <div
                    style={{
                      border: pieSectionData?.totalBookings
                        ? 'none'
                        : '1px solid green',
                    }}
                    className="dashboard-pie-bookings"
                  >
                    <h6 style={Headerstyles}>
                      {pieSectionData?.totalBookings | 0}
                    </h6>
                    <p>TotalBookings</p>
                  </div>
                </div>
                <div className="pie-data">
                  <div>
                    <p>Total booking amount</p>
                    <h3>
                      {currency == 'USD' ? '$' : '€'}{' '}
                      {pieSectionData?.totalEarnings?.toFixed(2)
                        ? pieSectionData?.totalEarnings?.toFixed(2)
                        : 0}
                    </h3>
                  </div>
                  <div className="count-container">
                    <div>
                      <h4>{pieSectionData?.statusCounts?.CONFIRMED | 0}</h4>
                      <p className="confirmed">Confirmed</p>
                    </div>
                    <div>
                      <h4>{pieSectionData?.statusCounts?.CANCELED | 0}</h4>
                      <p className="canceled">Canceled</p>
                    </div>
                    <div>
                      <h4>{pieSectionData?.statusCounts?.PENDING | 0}</h4>
                      <p className="pending">Pending</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="graph-loader">
                <ContentLoader width={400} height={250} viewBox="0 0 200 200">
                  <rect x="0" y="130" rx="2" ry="2" width="27" height="60" />
                  <rect x="40" y="115" rx="2" ry="2" width="27" height="75" />
                  <rect x="80" y="96" rx="2" ry="2" width="27" height="94" />
                  <rect x="120" y="50" rx="2" ry="2" width="27" height="140" />
                  <rect x="160" y="112" rx="2" ry="2" width="27" height="78" />
                </ContentLoader>
              </div>
            )}
          </div>
        </div>
        <div className="table-Row">
          <div className="table-container">
            <div className="total-bookings-heading-section">
              <h3 className="tb-heading">Booking Summary</h3>
              <div className="input-section">
                <div className="month-picker-wraper">
                  <input
                    max={maxMonth}
                    onChange={(event) => handleDateOnTable(event)}
                    className="month-picker-dashboard"
                    type="month"
                    value={tableMonth}
                  />
                  <div className="calender-image-container">
                    <img
                      width={24}
                      height={24}
                      src="/assets/calender.svg"
                      alt=""
                    />
                  </div>
                </div>
                <SearchableDropdown
                  setSearch={setFacilitySearch}
                  listItems={searchOption}
                  loading={isGetAllFacilityRequest}
                  submitValue={setFacilityIdInTable}
                />
                <form
                  onSubmit={(event) => handleTableSearch(event)}
                  className="table-search-input-section"
                >
                  <input
                    name="search"
                    className="input"
                    type="text"
                    placeholder="Search"
                    onChange={(event) => handleOnchange(event.target.value)}
                  />
                  <button type="submit" className="button">
                    {' '}
                    <img
                      src="assets/search-logo.svg"
                      alt=""
                      width={18}
                      height={18}
                    />
                  </button>
                </form>
                <button
                  style={{
                    border: '1.55px solid var(--Color-Grey-200, #e1e7ec)',
                    borderRadius: '7px',
                    cursor: 'pointer',
                  }}
                  type="button"
                  onClick={() =>
                    dispatch(
                      downloadTableData({
                        month: tableMonth,
                        searchTerm,
                        facilityId: facilityIdInTable,
                        filter: tableFilter,
                      })
                    )
                  }
                >
                  {!istableSummarydownloading ? (
                    <img
                      src="assets/download-logo.png"
                      alt=""
                      width={18}
                      height={18}
                    />
                  ) : (
                    <LoadingOutlined style={{ fontSize: 18 }} spin />
                  )}
                </button>
              </div>
            </div>
            <div
              style={{ minHeight: openFilter ? '200px' : 'auto' }}
              className="table-section"
            >
              <DashboardTable
                isLoading={istableSummaryFetching}
                tableData={tableSummary?.data?.[0]}
                filter={tableFilter}
                setFilter={setTableFilter}
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
                setPage={setTablePage}
              />
            </div>
            <div className="db-table-total-comm">
              <div className="db-commission-item">
                <h5>Total booking amount</h5>
                <h6>
                  ${' '}
                  {tableSummary?.data?.[0]?.totalEarnings
                    ? tableSummary?.data?.[0]?.totalEarnings.toFixed(2)
                    : '0.00'}
                </h6>
              </div>
              <div className="db-commission-item">
                <h5>Awaytogether commission (2.5%)</h5>
                <h6>
                  ${' '}
                  {tableSummary?.data?.[0]?.totalAwayTogetherCommission
                    ? tableSummary?.data?.[0]?.totalAwayTogetherCommission.toFixed(
                        2
                      )
                    : '0.00'}
                </h6>
              </div>
              <div className="db-commission-item">
                <h5>Total facility commission (5%)</h5>
                <h6>
                  ${' '}
                  {tableSummary?.data?.[0]?.totalAwayTogetherFacilityCommission
                    ? tableSummary?.data?.[0]?.totalAwayTogetherFacilityCommission.toFixed(
                        2
                      )
                    : '0.00'}
                </h6>
              </div>
            </div>
            <div className="table-pagination-wraper">
              <Pagination
                current={tablePage + 1}
                total={tableSummary?.data?.[0]?.payloads?.totalElements}
                pageSize={5}
                onChange={(page) => setTablePage(page - 1)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashBoardPage;
